module.exports = __webpack_public_path__ + "img/next-steps.37f5b318.svg";